import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export default function MontadorComunicados() {
  const [lista, setLista] = useState([]);
  const [det, setDet] = useState(null);

  const load = async () => {
    const r = await api.get("/comunicados/meus");
    setLista(r.data);
  };
  useEffect(() => { load(); }, []);

  const confirmar = async (c, aceite) => {
    try {
      await api.post(`/comunicados/${c.id}/confirmar-leitura`, { aceite });
      toast.success(aceite ? "Comunicado lido e aceito (registrado no log jurídico)" : "Leitura confirmada");
      setDet(null); load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const naoLidos = lista.filter(c => !c.lido);

  return (
    <>
      <div className="max-w-4xl mx-auto p-6 space-y-3">
        {naoLidos.length > 0 && (
          <div className="border-l-4 border-[#FFCC00] bg-[#FFCC00]/10 p-4 text-sm">
            <strong>{naoLidos.length} comunicado(s) não lido(s)</strong>
          </div>
        )}
        {lista.length === 0 && (
          <div className="border border-dashed border-border p-12 text-center text-sm text-muted-foreground">
            Nenhum comunicado recebido.
          </div>
        )}
        {lista.map(c => (
          <button key={c.id} onClick={() => setDet(c)}
            className={`block w-full text-left border-2 ${c.lido ? "border-border" : "border-[#FFCC00]"} bg-white p-4 hover:shadow-md transition`}
            data-testid={`mcom-${c.id}`}>
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="label-cap text-[#142766]">{c.empresa_nome}</div>
                <h2 className="font-heading font-bold mt-1">{c.assunto}</h2>
                <div className="text-xs text-muted-foreground mt-1">
                  {new Date(c.publicado_em).toLocaleString("pt-BR")} · {c.tipo}
                  {c.exige_aceite && <span className="ml-2 px-1.5 py-0.5 bg-[#FFCC00] text-[10px] uppercase">Exige aceite</span>}
                </div>
              </div>
              {c.lido && <span className="text-[10px] text-[#00A859]">✓ Lido</span>}
              {!c.lido && <span className="text-[10px] text-[#E60000]">● Novo</span>}
            </div>
          </button>
        ))}
      </div>

      <Dialog open={!!det} onOpenChange={(o) => !o && setDet(null)}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader><DialogTitle>{det?.assunto}</DialogTitle></DialogHeader>
          {det && (
            <div className="space-y-3">
              <div className="text-xs text-muted-foreground">
                {det.empresa_nome} · {new Date(det.publicado_em).toLocaleString("pt-BR")}
              </div>
              <div className="border border-border p-4 text-sm whitespace-pre-wrap max-h-[50vh] overflow-y-auto">
                {det.texto_revisado}
              </div>
              {det.lido && det.minha_leitura && (
                <div className="text-xs text-[#00A859]">
                  ✓ Confirmado em {new Date(det.minha_leitura.lido_em).toLocaleString("pt-BR")}
                  {det.minha_leitura.aceite && <span className="ml-2 font-bold">com aceite</span>}
                </div>
              )}
            </div>
          )}
          <DialogFooter>
            {det && !det.lido && (
              <>
                {det.exige_aceite ? (
                  <Button onClick={() => confirmar(det, true)} className="brand-bg text-white" data-testid="mcom-aceitar">
                    ✓ Li e aceito
                  </Button>
                ) : (
                  <Button onClick={() => confirmar(det, false)} className="brand-bg text-white" data-testid="mcom-li">
                    ✓ Confirmar leitura
                  </Button>
                )}
              </>
            )}
            {det?.lido && <Button onClick={() => setDet(null)}>Fechar</Button>}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
